import {Controller} from "react-hook-form";

const TextAreaRegComment = ({control, fieldName, absence_comment, height = '100%'}) =>
{

    return (
        <div>
            <Controller control={control} rules = {{maxLength: 999,}} name={fieldName} render={({field: {onChange, value}}) =>
                (
                    <textarea onChange={onChange} value={value} style={{width: "100%", height: height}}/>
                )}></Controller>
        </div>
    )
}

export default TextAreaRegComment;